// Change #100250 - "nothing ever loads" on a loyalty spinner link.
//
// Public pages (loyalty spinner, loyalty portal) find their company from the
// address they are opened on: the API reads the Origin and looks up
// Company.DedicatedUrlPrefix for https://{prefix}.portal.crmit.app. A link built
// from window.location.origin is only right while you are on your OWN portal -
// switched into another company from a different portal, the link carried the
// wrong prefix, the API looked in the wrong company, answered "not found", and
// the page sat on "Loading..." for ever.
//
// So public links are built on the logged-in company's own portal address,
// sent at login / company switch as get_company_data.Company_DedicatedUrlPrefix.
// Falls back to the current address when there is no prefix (older session,
// company without one) and on localhost, where the portal domain is not the
// thing being tested.
export const publicPortalOrigin = () => {
  try {
    const host = window.location.hostname || "";
    if (host === "localhost" || host === "127.0.0.1") {
      return window.location.origin;
    }
    const prefix = JSON.parse(localStorage.getItem("authUser") || "null")
      ?.get_company_data?.Company_DedicatedUrlPrefix;
    if (prefix && /^[a-z0-9-]+$/i.test(prefix)) {
      return `https://${prefix}.portal.crmit.app`;
    }
  } catch (e) {
    // fall through to the current address
  }
  return window.location.origin;
};

export default publicPortalOrigin;
